import { render } from "./SideBarLeft.vue?vue&type=template&id=f026b97c"
import script from "./SideBarLeft.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBarLeft.vue?vue&type=script&setup=true&lang=js"

import "./SideBarLeft.vue?vue&type=style&index=0&id=f026b97c&lang=scss"

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/app/sidebar/SideBarLeft.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f026b97c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f026b97c', __exports__)) {
    api.reload('f026b97c', __exports__)
  }
  
  module.hot.accept("./SideBarLeft.vue?vue&type=template&id=f026b97c", () => {
    api.rerender('f026b97c', render)
  })

}


export default __exports__